import parser from './parser/parser'

export default parser
